<box size="sm">
  <app-header [title]="'ship_interface.create_new_port_report' | transloco" [onClose]="onClosePress"></app-header>
  <app-body>
    <div>
      <div class="flex flex-row gap-2 px-9 py-3">
        <form-date-picker
          [label]="'ship_interface.report_date' | transloco"
          [required]="true"
          class="w-full"
          [control]="form.get('date_report')"></form-date-picker>
        <textbox
          [label]="'ship_interface.current_voyage_number' | transloco"
          [required]="true"
          [placeholder]="'ship_interface.enter_current_voyage_number' | transloco"
          class="w-full"
          [control]="form.get('voyage_number')"></textbox>
      </div>
      <selection-button
        [label]="'ship_interface.select_port_report_type' | transloco"
        [required]="true"
        [buttons]="buttons()"
        (buttonsChange)="onButtonsChange($event)">
      </selection-button>
    </div>
  </app-body>
  <app-footer [saveButtonTitle]="'button.next' | transloco" [onSave]="onSavePress" [onDiscard]="onDiscard" [disabledSaveButton]="form.invalid"></app-footer>
</box>
